import { useParams } from "react-router-dom";
import { DatasetSchemaListResponse } from "datasets/types/interfaces/dataset-schema";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

interface UseDatasetSchemasParams {
  limit?: number;
  offset?: number;
}

const useDatasetSchemas = ({ limit = 20, offset = 0 }: UseDatasetSchemasParams = {}) => {
  const { datasetId } = useParams();

  const query = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });

  return useFetcher<DatasetSchemaListResponse>(
    datasetId ? `${VITE_CATALOG_API}/v1/datasets/${datasetId}/schemas?${query.toString()}` : null
  );
};

export default useDatasetSchemas;
